import { AssetType } from '@amzn/fire-tv-campaign-automation-service';
import { FeatureFlag, isFeatureEnabled } from 'src/featureFlags';

import {
  FireTVControlKey,
  FireTVPreviewState,
  PreviewConfigBase,
  PreviewControlType,
  PreviewControlValue,
  PreviewControlKey,
  PreviewGenerationStrategy,
} from '../types';

import { FIRETV_FEATURE_ROTATOR_STATE_CONFIGS } from './stateConfigs';

/**
 * FireTV Feature Rotator Preview Configuration
 *
 * Defines preview behavior for FireTV Feature Rotator placement
 *
 * States:
 * - Selected: Upscaled background (2410x904), fixed logo, shell overlay
 * - Unselected: Standard background with -33 y offset, fixed logo, shell overlay
 * - Video: Video trailer with center crop
 *
 * Behavior:
 * - Strategy: CURRENT_VARIANT - generates preview on demand
 * - Controls: Button group to toggle between states
 *
 * Canvas: 1920x1080
 */
export const FIRE_TV_FEATURE_ROTATOR_CONFIG: PreviewConfigBase = {
  defaultState: FireTVPreviewState.UNSELECTED,
  controls: [
    {
      type: PreviewControlType.BUTTON_GROUP,
      key: FireTVControlKey.STATE,
      label: 'Preview State',
      options: [
        { label: 'Unselected', value: FireTVPreviewState.UNSELECTED },
        { label: 'Selected', value: FireTVPreviewState.SELECTED },
        { label: 'Video', value: FireTVPreviewState.VIDEO },
        ...(isFeatureEnabled(FeatureFlag.RdpIntegration)
          ? [{ label: 'Device Preview', value: FireTVPreviewState.DEVICE_PREVIEW }]
          : []),
      ],
      defaultValue: FireTVPreviewState.UNSELECTED,
    },
  ],
  behavior: {
    previewGeneration: PreviewGenerationStrategy.CURRENT_VARIANT,
    stateResolution: (values: Record<PreviewControlKey, PreviewControlValue>) => {
      return (values[FireTVControlKey.STATE] ||
        FireTVPreviewState.UNSELECTED) as FireTVPreviewState;
    },
  },
  stateConfigs: FIRETV_FEATURE_ROTATOR_STATE_CONFIGS,
  downloads: {
    includeAssets: true,
    includePreviews: false,
    supportedAssets: [AssetType.BACKGROUND_IMAGE, AssetType.LOGO, AssetType.VIDEO_TRAILER],
  },
};
